import React from "react";
import { faBars, faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
const DashboardWrapper = ({children}) => {
  const toggleMenu = () => {
    let toggle = document.querySelector(".dashboard_toggle");
    let navToggle = document.querySelector(".dashboard_navigation");
    let mainToggle = document.querySelector(".dashboard_main");
    toggle.classList.toggle("active");
    navToggle.classList.toggle("active");
    mainToggle.classList.toggle("active");
  };
  return (
    <div className="dashboard_main">
      <div className="dashboard_topbar w-100">
        <div className="dashboard_toggle" onClick={toggleMenu}>
          <FontAwesomeIcon icon={faBars} className="iconBars" />
        </div>
        <div className="dashboard_search">
          <label htmlFor="searchBox">
            <input
              className=""
              type="text"
              name="searchBox"
              id="searchBox"
              placeholder="search here"
            />
            <FontAwesomeIcon icon={faSearch} className="search_icon" />
          </label>
        </div>
        <div className="dashboard_user">
          <img
            className="img-fluid"
            src="https://i.ibb.co/RSbfzf7/4-190687129806558e-27.jpg"
            alt="user"
          />
        </div>
      </div>
      {children}
    </div>
  );
};

export default DashboardWrapper;
